import React from 'react'
import { up } from 'styled-breakpoints'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import AppStore from '../../../../common/app-store'
import Argument from './argument'

export type PointProps = {
    number: number
    name: string
    userImage: string
}

const Point: React.FunctionComponent<PointProps> = ({ number, name, userImage }) => {
    const { i18n } = useTranslation()
    const lang = i18n.language

    const image = require(`./images/selling_points/${lang}/${name}.webp`)

    // That could be it, but safari doesn't support webp so we also need a fallback png
    const fuckSafariImage = require(`./images/selling_points/${lang}/${name}.png`)

    const even = (number % 2 === 0)

    return (
        <Container even={even}>
            <Picture even={even}>
                <source media={"(min-width:0)"} srcSet={image} type='image/webp' />
                <Image src={fuckSafariImage} />
            </Picture>
            <ArgumentContainer even={even}>
                <Argument name={name} userImage={userImage} />
            </ArgumentContainer>
            <StoreContainer even={even}>
                <AppStore />
            </StoreContainer>
        </Container>
    )
}

const Container = styled.div<{even: boolean}>`
    display: grid;
    
    justify-items: center;
    grid-row-gap: 16px;

    justify-self: center;

    ${up('mobileBig')} {
        grid-gap: 20px;
    }

    ${up('tablet')} {
        grid-gap: 24px;
    }

    ${up('desktop')} {
        grid-template-columns: 1fr 1fr;
        grid-template-rows: auto 1fr;
        grid-template-rows: repeat(auto auto);
        width: 1024px;
    }
`

const Picture = styled.picture<{even: boolean}>`
    width: 267px;

    filter: drop-shadow(0px 24px 64px ${p => p.theme.colors.inactive});
    margin-bottom: 25px;

    ${up('desktop')} {
        width: 350px;
        grid-row: span 2;
        grid-column: ${p => p.even ? '1' : '2'};
    }
`

const Image = styled.img`
    width: 100%;
`

const StoreContainer = styled.div<{even: boolean}>`
    display: grid;
    justify-items: center;
    width: 100%;

    ${up('desktop')} {
        justify-items: flex-start;
        grid-row: 2;
        grid-column: ${p => p.even ? '2' : '1'};
    }
`

const ArgumentContainer = styled.div<{even: boolean}>`
    display: grid;
    justify-items: center;
    width: 100%;

    ${up('desktop')} {
        justify-items: flex-start;
        align-items: flex-start;
        
        grid-row: 1;
        grid-column: ${p => p.even ? '2' : '1'};
    }
`

export default Point